<template>
  <div
    v-if="log.info"
    class="comment_log"
  >
    {{ formatDate(log.created_at) }} –
    <span v-if="log.from_workflow">
      <a-icon type="robot"/>&nbsp;
    </span>
    <Performer :data="log.user"/>
    <span>
      {{ $t('history.verb.comments') }}
    </span>
    <div
      v-if="commentActionsAllowed()"
      class="comment_actions"
    >
      <a-icon
        type="close"
        @click="deleteComment"
      />
      <a-icon
        type="edit"
        @click="editComment"
      />
    </div>
    <div
      v-if="!editMode"
      class="comment_entry"
      v-html="log.info.comment"
    />
    <CommentsForm
      v-else
      :data="log.info.comment"
      :id="log.id"
      :resource="resource"
    />
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
import HistoryMixin from '@/components/layout-components/widgets/history/history-mixin'

export default {
  name: 'CommentEntity',
  mixins: [HistoryMixin],
  data () {
    return {
      editMode: false,
    }
  },
  props: {
    log: {
      type: Object,
      default: undefined,
    },
    resource: {
      type: Object,
      default: undefined,
    },
  },
  mounted () {
    EventBus.$on('cancelEdit', (id) => {
      if (id === this.log.id) {
        this.editMode = false
      }
    })
  },
  methods: {
    commentActionsAllowed () {
      return this.$store.state.userInfo.isRoot || this.log.user.id === this.$store.state.userInfo.id
    },
    deleteComment () {
      this.resource.deleteComment(this.log.id).then(response => {
        EventBus.$emit('reloadHistory')
      })
    },
    editComment () {
      this.editMode = true
    },
  },
}
</script>

<style lang="scss" scoped>
.comment_log{
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
.comment_actions{
  float: right;
}
.comment_actions i{
  cursor: pointer;
  padding: 5px;
  margin-left: 3px;
  border-radius: 5px;
}
.comment_actions i:hover{
  background: #f0f0f0;
}
</style>
<style lang="scss">
.comment_entry p:last-of-type{
  margin-bottom: 0;
}
</style>
